import { WebClientListResourceFetcher } from '~commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';

import { Resource } from '../../../resources/Resource';
import { GetSiteNamesAcrossAllPodsRequest, IGetSiteNamesAcrossAllPodsResult } from '../../../ServerApi/requests/GetSiteNamesAcrossAllPodsRequest';
import { ISiteNameSansId } from '../../../ServerApi/types/ISiteNameSansId';

export class SiteNameSansIds extends Resource<ISiteNameSansId> {

  public static readonly instance = new SiteNameSansIds(new WebClientListResourceFetcher(GetSiteNamesAcrossAllPodsRequest, (result: IGetSiteNamesAcrossAllPodsResult) => {
    return result.siteNames;
  }));

}
